import React from 'react';
import { useParams, useSearchParams } from 'react-router';
import AuthGate from '..';
import ChatViewer from '../../../pages/ChatViewer';

interface WrapperProps {
	baseRoute: string;
}

// this allows for custom inject of params into the redirPage var on the AuthGate *without* putting special cases into the route component itself

export const ChatViewerWrapper: React.FC<WrapperProps> = ({ baseRoute }) => {
	let route = baseRoute;

	const params = useParams();
	const [searchParams] = useSearchParams();

	if (params.pipelineType) {
		route += `/${params.pipelineType}`;
	}

	if (params.container) {
		route += `/${params.container}`;
		if (params.fileName) {
			route += `/${params.fileName}`;
		}
	}
	if (searchParams) {
		route += `?${searchParams}`;
	}
	route += window.location.hash;

	return (
		<AuthGate redirPage={route}>
			<ChatViewer />
		</AuthGate>
	);
};
